import * as Utils from 'utils';

export const userProfileMiddleware = () => (next) => (currentAction) => {
  let action = {...currentAction};

  if (currentAction.type === 'order/checkAndUpdateIfUserProfileExists') {
    if (window['userProfile'] && Object.keys(window['userProfile']).length) {
      const userProfile = window['userProfile'];
      const userProfileDecoded = Utils.decodeHtmlInObject(userProfile);

      action = {
        ...action,
        payload: userProfileDecoded
      };
    }
  }
  next(action);
}
